import {useCategories} from '@salesforce/commerce-sdk-react'

const useDataLayerProducts = (productMap, basket) => {
    const giftCertificateItems =
        basket?.giftCertificateItems?.map((giftCertificateItem) => ({
            name: 'Gift Certificate',
            id: giftCertificateItem.giftCertificateItemId,
            category: 'Gift Cards',
            brand: 'Cavenders',
            variant: 'GCARD',
            price: giftCertificateItem.amount?.toFixed(2),
            quantity: '1'
        })) || []

    const categoryIds =
        basket?.productItems
            ?.map((item) => {
                const productData = productMap?.[item.productId]
                return productData?.primaryCategoryId || productData?.c_primaryCatergoryID
            })
            .filter(Boolean)
            .filter((id, index, array) => array.indexOf(id) === index) || []

    const {data: categories, isLoading: isCategoriesLoading} = useCategories({
        parameters: {ids: categoryIds},
        enabled: categoryIds.length > 0 && !!productMap && !!basket
    })

    if (categoryIds.length > 0 && isCategoriesLoading) {
        return []
    }

    const productItems =
        (productMap &&
            basket?.productItems?.map((item) => {
                const productData = productMap?.[item.productId]
                if (!productData) return null

                const category = categories?.data?.find(
                    (cat) =>
                        cat.id ===
                        (productData.primaryCategoryId || productData.c_primaryCatergoryID)
                )
                return {
                    name: item.productName || productData.name,
                    id: productData?.master?.masterId || productData?.id,
                    price: (item.priceAfterOrderDiscount || item.price).toFixed(2),
                    brand: productData.brand || productData.manufacturerName || '',
                    category: category?.parentCategoryTree?.map((cat) => cat.name).join('/') || '',
                    variant: productData?.id,
                    quantity: item.quantity,
                    coupon: item?.priceAdjustments?.[0]?.couponCode || null,
                    dimension7: productData.c_shipToHomeOnPWA?.enableShipToHome ? 'Ship' : 'BOPIS',
                    ATS: productData.inventory?.ats?.toString() || '',
                    onlineFlag:
                        productData.c_onlineIndecator === 'WEB ELIGIBLE' ||
                        productData.c_availableToShip ||
                        false,
                    bopis_type: item.c_storepickup ? 'BOPIS' : 'Ship',
                    bopis_eligble: productData?.c_instorePickupOnPWA?.enableInStorePickup
                }
            })) ||
        []

    const products = [...productItems, ...giftCertificateItems].filter(Boolean)

    return products
}

export default useDataLayerProducts
